/** @jsx isolateComponent */
import { css } from '@emotion/core';
import { Colors, Heading, HeadingLevel, Typography, } from '@zapier/design-system';
import { isolateComponent } from '@zapier/style-encapsulation';
import Folder from '../Folder';
const folderGroupTitleCss = css `
  ${Typography.smallPrint1Bold}
  color: ${Colors.neutral700};
  font-size: 12px;
  line-height: 40px;
`;
const foldersCss = css `
  display: grid;
  grid-row-gap: 5px;
`;
/** Renders a single group of folders within `<Browser>`. */
const FolderGroup = ({ folders, forceFoldersOpen, onSelect, title, }) => {
    return (isolateComponent("li", null,
        isolateComponent(Heading, { css: folderGroupTitleCss }, title),
        isolateComponent(HeadingLevel, null,
            isolateComponent("ul", { css: foldersCss }, folders.map(folder => (isolateComponent(Folder, Object.assign({ forceOpen: forceFoldersOpen, key: folder.id, onSelect: onSelect }, folder))))))));
};
export default FolderGroup;
